<template>
  <button-base :channel="channel" :show-button-labels="showButtonLabels" @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import WhatsappMixin from '@/share/campaign/whatsapp-mixin'

export default {
  components: { ButtonBase },

  mixins: [WhatsappMixin],

  props: {
    channel: {
      type: Object,
      required: true
    },

    showButtonLabels: {
      type: Boolean,
      required: true
    }
  }
}
</script>
